module.exports = __webpack_public_path__ + "static/img/number1.3364a94e.png";